module.exports = __webpack_public_path__ + "static/img_2570-170b5f51c4d6456f66ca6851d96ae0d7.webp";